<template>
    <div class="achievement">
      <Header msg='我的业绩' type='Team'/>
      <div style="height:0.5rem" v-if="userLevel == 4"></div>
      <Navbar :selected.sync="selected" :selecteData="selecteData" v-if="userLevel == 4"/>

      <!-- <div class="ach-context" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" v-if="!shownull">
        <div class="per-line" v-for="(e, i) in pageData" :key="i">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <div class="flex flex-a-i-center">
                    <img :src="e.avatar_url" class="item-avatar"/>
                    <p class="item-name">{{e.nickname}}</p>
                </div>
                <p class="item-time">{{e.pay_time}}</p>
            </div>
            <div class="flex flex-j-c-sb flex-a-i-center">
                <p class="item-text">报考#{{e.first_name}}{{e.goods_name}}专业#</p>
                <p class="item-num">+{{e.percentage}}</p>
            </div>
        </div>
      </div>
      <DataNull v-if="shownull"/> -->
      <router-view />

    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import {getAchievement} from '@/api';
import { Indicator, MessageBox, Toast } from 'mint-ui';
import Navbar from '@/components/Navbar.vue';

export default {
    name: 'Achievement',
    components: {
      Header,
      // DataNull,
      Navbar,
    },
    data() {
      return {
        // pageData: [],
        // loading: true,
        // page: 1,
        // shownull: false,
        selected: 0, // Navbar索引
        selecteData: [{id: 1, name: '团队业绩', num: 0}, {id: 2, name: '渠道业绩', num: 0}], // Navbar数据
        userLevel: 0 // 用户等级
      }
    },
    watch:{
      selected(newVal, oldVal) {
        window.scrollTo(0, 0);
        switch (newVal) {
          case 0:
            this.$router.replace({path:"/Achievement/AchiPre", query:{id:this.userLevel}})
            break;
          case 1:
            this.$router.replace({path:"/Achievement/AchiTeam", query:{id:this.userLevel}})
            break;
          default:
            break;
        }
      }
    },
    created() {
      // this.getAchievementList();
      this.userLevel = this.$route.query.id;
      switch (window.location.pathname) {
        case "/Achievement/AchiPre":
          this.selected = 0
          break;
        case "/Achievement/AchiTeam":
          this.selected = 1
          break;
        default:
          break;
      }
    },
    methods: {
      //到底加载
      // loadMore(){
      //   if (this.loading) return false;
      //   this.loading = true
      //   this.page += 1;
      //   this.getAchievementList();
      // },
      // getAchievementList() {
      //   getAchievement({page: this.page, limit: 10}).then(res => {
      //     if (res.code === 0) {
      //       this.pageData = this.pageData.concat(res.data);
      //       if (res.data.length === 0) { this.shownull = true };
      //       if (res.data.length === 10) this.loading = false
      //     } else {
      //       console.log(res.msg);
      //       this.shownull = true 
      //     }
      //   });
      // }
    }
}

</script>
<style lang='less' scoped>
.achievement{
    width: 100%;
    min-height: 100vh;
    .Navbar{
      top: 0.44rem;
      border-top: 1px solid #eee;
      position: fixed
    }
    // .ach-context{
    //     border-top: 1.04rem solid #f6f6fa;
    //     background: white;
    //     padding: 0 0.16rem;
    //         &>:last-child{
    //             border: none;
    //         }
    //         .per-line{
    //             height: auto;
    //             line-height: 0.4rem;
    //             padding: 0.1rem 0;
    //         }
    //         .item-avatar{
    //             width: 0.23rem;
    //             height: 0.23rem;
    //             margin-right: 0.12rem;
    //             border-radius: 50%;
    //         }
    //         .item-name{
    //             font-size: 0.16rem;
    //         }
    //         .item-time{
    //             color: #999999;
    //             font-size: 0.12rem;
    //         }
    //         .item-text{
    //             font-size: 0.14rem;
    //             color: #333333;
    //             width: 75%;
    //             text-align: left;
    //         }
    //         .item-num{
    //             font-size: 0.18rem;
    //             color: #FABD01;
    //         }
    // }
}
</style>